import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1,
      [theme.breakpoints.down('xs')]: {
        display: 'block',
        lineHeight: 1.2
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '20px',
        lineHeight: 1.2
      }
    },
    dashSpacer: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    },
    subTitle: {
      [theme.breakpoints.down('xs')]: {
        display: 'block',
        lineHeight: 1.1
      }
    }
  });

export interface SectionHeaderTextProps {
  title: string;
  subTitle?: string;
  id?: string;
}
type Props = SectionHeaderTextProps & WithStyles<typeof styles>;
const SectionHeaderText = (props: Props) => {
  const { title, subTitle, classes, id } = props;

  const _subTitle = !subTitle ? null : (
    <Typography
      color="inherit"
      variant="h3"
      component="span"
      className={classes.subTitle}
    >
      <span className={classes.dashSpacer}>-</span>
      {subTitle}
    </Typography>
  );

  return (
    <Typography color="primary" id={id} variant="h2" className={classes.root}>
      {title}
      {_subTitle}
    </Typography>
  );
};

export default withStyles<'root', {}, SectionHeaderTextProps>(styles, {
  name: 'FdSectionHeaderText'
})(SectionHeaderText);
